const links = [
  {
    icon: 'ri-file-list-3-line',
    title: 'Demander une soumission',
    desc: 'Soumission gratuite en 2h',
    href: '/soumission-gratuite',
    isExternal: false,
  },
  {
    icon: 'ri-tools-line',
    title: 'Voir nos services',
    desc: 'Toutes nos solutions toiture',
    href: '/toiture-levis',
    isExternal: false,
  },
  {
    icon: 'ri-article-line',
    title: 'Notre blog',
    desc: 'Conseils et guides pratiques',
    href: '/blog/prix-toiture-levis-2026',
    isExternal: false,
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Nous contacter',
    desc: 'Par téléphone ou email',
    href: 'tel:+14184769950',
    ariaLabel: 'Appeler Couvreur-Lévis.com au 418-476-9950',
    title: 'Cliquez pour appeler',
    isExternal: true,
  },
];

export default function LiensRapides() {
  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <h2 className="text-xl md:text-2xl font-bold text-slate-primary text-center mb-10">
          Que voulez-vous faire ?
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {links.map((link) => (
            link.isExternal ? (
              <a
                key={link.href}
                href={link.href}
                aria-label={(link as { ariaLabel?: string }).ariaLabel}
                title={(link as { title?: string }).title}
                className="group flex flex-col items-center text-center p-6 rounded-lg border border-soft-dark bg-white hover:border-copper hover:shadow-lg transition-all duration-300"
              >
                <span className="w-14 h-14 flex items-center justify-center rounded-full bg-copper/10 group-hover:bg-copper/20 transition-colors mb-4">
                  <i className={`${link.icon} text-2xl text-copper`} />
                </span>
                <h3 className="font-semibold text-slate-primary mb-1 group-hover:text-copper transition-colors">
                  {link.title}
                </h3>
                <p className="text-sm text-slate-primary/60">{link.desc}</p>
              </a>
            ) : (
              <button
                key={link.href}
                onClick={() => navigateTo(link.href)}
                className="group flex flex-col items-center text-center p-6 rounded-lg border border-soft-dark bg-white hover:border-copper hover:shadow-lg transition-all duration-300 cursor-pointer w-full"
              >
                <span className="w-14 h-14 flex items-center justify-center rounded-full bg-copper/10 group-hover:bg-copper/20 transition-colors mb-4">
                  <i className={`${link.icon} text-2xl text-copper`} />
                </span>
                <h3 className="font-semibold text-slate-primary mb-1 group-hover:text-copper transition-colors">
                  {link.title}
                </h3>
                <p className="text-sm text-slate-primary/60">{link.desc}</p>
              </button>
            )
          ))}
        </div>
      </div>
    </section>
  );
}